import React, { useContext, useCallback, useMemo, useState } from 'react';
import { Chevron } from '@jutro/components';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import CoveragesComponent from '../../../../Components/CoveragesComponent/CoveragesComponent';
import ScheduleItemsDisplayComponent from '../../../../Components/ScheduleItemsDisplayComponent/ScheduleItemsDisplayComponent';
import metadata from './PolicyCommericalPropertyInfoComponent.metadata.json5';
//import styles from '../../Summary.module.scss';
import styles from './PolicyCommericalPropertyInfoComponent.module.scss';
import messages from './PolicyCommericalPropertyInfoComponent.messages';
import PolicyDwellingInfo from './../../ho/PolicyDwellingInfo/PolicyDwellingInfo';


const getHeaderSection = (title, title1, title2) => {
    return (isOpen) => (
        <React.Fragment>
            <Chevron isOpen={isOpen} align="right" className={styles.chevronStyle} />
            <h2 className={`${styles.title} ${styles.gwOverrideDefaultMargin}`}>{title}</h2>
            <div className={styles.row} >
                {
                    title1 && 
                    <div > 
                        <h3 className={`${styles.title1} ${styles.gwOverrideDefaultMargin}`}>{title1}</h3>
                    </div>
                }
                { 
                    title2 && 
                    <div>
                        <h3 className={`${styles.title1} ${styles.gwOverrideDefaultMargin}`}>{title2}</h3>
                    </div>
                }                
            </div>
        </React.Fragment>
    );
};

function PolicyCommercialPropertyInfoComponent(props) {
    const cpLobData = props.value;
    const {coverables, isQuote} = props;
    const lineData = coverables.filter((cov) => { return cov.name === 'Commercial Property' })[0];
    const liabilityLineData = coverables.filter((cov) => { return cov.name === 'Liability Line' })[0];
    const translator = useContext(TranslatorContext);
    const [openItems, setOpenItems] = useState([]);

    const generateBuildingHeaderName = useCallback((location, locationIndex) => {
        const overrides = location.buildings.map((building, index) => {
            const title = 'Building : '+ building.name;
            const title1 = `Item type: ${building.buildingType || '-'}`;
            const title2 = `Value: ${building.buildingValue || '-'}`;
            return {
                [`CPBuildingCoverageDetailsHeader${locationIndex}${index}`]: {
                    header: getHeaderSection(title, title1, title2)
                },
            };
        });
        return Object.assign({}, ...overrides);
    },[]);

    const toggleShowHide = useCallback(
        (item) => {
            const openedItem = _.clone(openItems);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                setOpenItems(openedItem);
            } else {
                setOpenItems(_.slice(openedItem, index, 0));
            }
        },
        [openItems]
    );

    const generateAccordionHeaderOverrides = useCallback(() => {
        const productCode = cpLobData.lineOfBusiness;
        if(cpLobData.locations !== undefined){
            const overrides = cpLobData.locations.map((location, index) => {
                location.dwellingDTO = location.buildings;
                const packageType = location.packageType || translator({id: `typekey.BOPPackageTypes_EY.${location.packageType_EY}`});
                const title = translator(messages.LocationName, {name: location.displayName});
                const title1 = translator(messages.PackageName, {type: packageType, number: location.packageNumber});
                //const title = 'Location : '+ location.displayName;
                //const title1 = `Package #${location.packageNumber}: ${location.packageType}`;
                return {
                    [`cpPackageDetailsContainer${index}`]: {
                        header: getHeaderSection(title, title1)
                    },
                    [`contentDetailToggle${index}`]: {
                        icon: _.includes(openItems, index) ? 'caret-up' : 'caret-down',
                        message: _.includes(openItems, index)
                            ? translator(messages.hideCoverages)
                            : translator(messages.showCoverages)
                    },
                    [`CoverageContainer${index}`]: {
                        visible: _.includes(openItems, index),
                        show: openItems
                    },
                    [`accordionEmptyMsg${index}`]:{
                        visible: location.coverages.length == 0
                    },
                    [`showContentToggleLink${index}`]: {
                        onClick: () => toggleShowHide(index)
                    },
                    [`policyDwellingPropertyInfo${index}`]:{
                        value: location,
                        productCode: props.isQuote ? 'Commercial Property' : productCode
                    },
                    ...generateBuildingHeaderName(location, index)
                };
            });
            return Object.assign({}, ...overrides);
        }
        return Object.assign({}, []);
    }, [cpLobData, openItems]);


    const overrides = {
        coveragesSection:{
            data: lineData,
            header: getHeaderSection(translator(messages.CPCoverages), '')
        },
        // liabilityCoveragesSection: {            
        //     data: liabilityLineData,
        //     header: getHeaderSection(translator(messages.LiabilityLine), '')
        // },
        policyCoverageName:{
            data: lineData,
            value: lineData !== undefined ? lineData.name : ''
        },
        policyCoverage: {
            data: lineData,
            value: lineData !== undefined ? lineData.coverages : ''
        },
        // liabilityCoverage: {
        //     visible: !!liabilityLineData,
        //     data: liabilityLineData,
        //     value: liabilityLineData ? liabilityLineData.coverages : []
        // },
        // liablityEmpty:{
        //     visible: !liabilityLineData,
        // },
        ...generateAccordionHeaderOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            coveragescomponent: CoveragesComponent,
            scheduleitemscomponent: ScheduleItemsDisplayComponent,
            policydwellingcomponent: PolicyDwellingInfo,
        }
    };
    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={cpLobData}
            overrideProps={overrides}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}
PolicyCommercialPropertyInfoComponent.propTypes = {
    value: PropTypes.shape({}).isRequired
};
export default PolicyCommercialPropertyInfoComponent;
